import { render } from "./injuryIdentificationStatistics.vue?vue&type=template&id=223a8c18&scoped=true"
import script from "./injuryIdentificationStatistics.vue?vue&type=script&lang=js"
export * from "./injuryIdentificationStatistics.vue?vue&type=script&lang=js"

import "./injuryIdentificationStatistics.vue?vue&type=style&index=0&id=223a8c18&lang=scss&scoped=true"
import "./injuryIdentificationStatistics.vue?vue&type=style&index=1&id=223a8c18&lang=scss&scoped=true"
import "./injuryIdentificationStatistics.vue?vue&type=style&index=2&id=223a8c18&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223a8c18"]])

export default __exports__